import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-16 md:py-20 relative overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20gradient%20abstract%20background%20with%20soft%20orange%20and%20cream%20tones%2C%20subtle%20geometric%20patterns%2C%20minimalist%20modern%20design%2C%20clean%20composition%2C%20gentle%20atmospheric%20light%2C%20suitable%20for%20call%20to%20action%20section&width=1800&height=600&seq=cta-bg-hanman&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-accent-500/85"></div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-4">
          立即下载韩漫之家APK
        </h2>
        <p className="text-base text-background-50/80 mb-8 leading-relaxed">
          免费获取韩漫之家APK，海量韩漫资源自由下载，
          支持韩漫离线免费下载，随时随地畅享韩漫全集。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/article/5"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-background-50 text-primary-600 text-base font-semibold rounded-full hover:bg-background-100 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-android-line text-lg w-5 h-5 flex items-center justify-center"></i>
            韩漫下载安装
          </Link>
          <Link
            to="/article/2"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-transparent text-background-50 text-base font-medium rounded-full border border-background-50/40 hover:bg-background-50/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-guide-line text-lg w-5 h-5 flex items-center justify-center"></i>
            下载使用指南
          </Link>
        </div>
      </div>
    </section>
  );
}